<script setup lang="ts">
import { messageLogin, messageLoginEmpty } from '@/event/account/alert/messageLogin'
import { useRouter } from 'vue-router'

const router = useRouter()

function toRegister() {
    router.push({ name: 'register' })
    messageLogin.value = messageLoginEmpty
    // router.push({ name: 'register', query: { theme: 'happy' } }) // Uncomment if you need to pass theme as a query parameter
}
</script>

<template>
    <button class="button-link-register-happy" @click="toRegister">
        <p class="text-button-link-register-happy">S'inscrire</p>
    </button>
</template>

<style scoped>
.button-link-register-happy {
    @apply bg-button-yellow-happy-light w-44 p-1 rounded-md font-semibold text-text-dark-happy-light;
}
.button-link-register-happy:active {
    @apply bg-hover-yellow-happy shadow-sm shadow-text-dark-happy-light;
}

@media (hover: hover) {
    .button-link-register-happy:hover {
        @apply bg-hover-yellow-happy shadow-sm shadow-text-dark-happy-light;
    }
}
</style>
